import React from 'react';
import SpecGrid from './SpecGrid';
import ProductPanels from './ProductPanels';
import { buildSpecs } from './specyfikacjaModelu';

/**
 * Dane MODELU pokazane na stronie pojedynczej oferty.
 *
 * PO CO: oferta sklepu opisuje warunki zakupu (cena, sprzedawca, wysyłka,
 * dostępność), ale to wciąż ten sam produkt co na stronie modelu. Bez tej sekcji
 * ktoś, kto wszedł prosto z wyszukiwarki na konkretną ofertę, widział cenę
 * i nazwę, a parametry, kartę katalogową i opis musiał doklikać przez model.
 *
 * CZEGO TU NIE MA I NIE BĘDZIE: sytuacji rynkowej (rozrzut cen, liczba ofert,
 * historia). To wiedza o CAŁYM rynku danego modelu i ma jedno naturalne miejsce —
 * stronę modelu. Powtórzona przy pojedynczej ofercie myli: użytkownik czyta
 * „najniższa cena 480 zł", patrząc na ofertę za 560 zł.
 *
 * DANE SĄ MODELU, NIE OFERTY, i tak są opisane. Pojedyncza oferta bywa uboga —
 * sklep podaje trzy pola z dwunastu — a scalony rekord modelu ma komplet.
 * Etykieta „dane platformowe · scalone z ofert" jest ta sama, co na stronie modelu,
 * bo to dokładnie ta sama warstwa danych.
 */
const DaneModeluNaOfercie = ({ model, category }) => {
  if (!model || model.id == null) return null;

  const specs = buildSpecs(model, category).filter((s) => s.value != null);
  const maSpecs = specs.length > 0;
  const maPanele = Boolean(
    model.electrical_spec || (model.description_paragraphs || []).length,
  );
  if (!maSpecs && !maPanele) return null;

  return (
    <>
      {maSpecs && (
        <div className="max-w-7xl mx-auto px-4 md:px-8 mt-6">
          <div className="bg-white rounded-2xl border border-gray-200 shadow-sm p-5 md:p-7">
            {/* Bez odnośnika do strony modelu — jest już w nagłówku oferty
                („Porównaj wszystkie oferty"). Dwa linki obok siebie prowadzące
                w to samo miejsce każą się zastanawiać, czym się różnią. */}
            <div className="flex flex-wrap items-center gap-2 mb-3">
              <h2 className="text-sm font-bold text-gray-900">Dane produktu</h2>
              <span className="text-[11px] px-2 py-0.5 rounded-md bg-gray-100 text-gray-500">
                dane platformowe · scalone z ofert
              </span>
            </div>
            <SpecGrid items={specs} />
          </div>
        </div>
      )}

      {/* Parametry elektryczne, karta katalogowa i opis — ten sam pasek zakładek
          co na stronie modelu. Bez kompatybilności: ta prowadzi do porównywarki
          par modeli, a nie do zakupu tej konkretnej oferty. */}
      <ProductPanels
        spec={model.electrical_spec}
        category={category}
        paragraphs={model.description_paragraphs}
        compat={null}
      />
    </>
  );
};

export default DaneModeluNaOfercie;
